import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';

const ErrorPage: React.FC<RouteComponentProps<any>> = (props) => {
    const code = props.match.params.code;
    return (
        <div>
            <h1>Error</h1>
            <p>
                {
                    code == 'email-confirm'
                        ? 'The email confirmation link you used is invalid or expired.'
                        : 'An unknown error has occured.'
                }
            </p>
            {code && <p>Code: {code}</p>}
        </div>
    );
};


export default ErrorPage; 